import React, { useEffect, useState } from "react";
import PureCounter from "@srexi/purecounterjs";
import { BASE_URL } from "../../../Components/Base_url/Base_Url";
import './Expre.css';
function Experenise() {
    const [loading, setLoading] = useState(true);
    const [Facts, setFacts] = useState([]);

    const fetchFacts = async () => {
        try {
            const response = await fetch(`${BASE_URL}/experience/`);
            const data = await response.json();
            if (data?.data) {
                setFacts(data.data);
            }
        } catch (error) {
            console.error("Error fetching facts:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchFacts();
    }, []);

    // 👇 Re-initialize PureCounter after facts are updated
    useEffect(() => {
        if (!loading) {
            new PureCounter();
        }
    }, [loading, Facts]);

    return (
        <section className="experience-sec py-5">
            <div className="container">
                <div
                    className="row g-4 p-5 rounded-3 experience-bg"
                >
                    {loading ? (
                        <div className="overlay-loader text-center">
                            <div className="spinner-border text-warning" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        Facts.map((fact, index) => (
                            <div className="col-lg-3 col-md-6" key={index}>
                                <div className="exp-card text-center p-4 rounded-3 h-100 shadow-sm">
                                    <div className="exp-icon mb-3">
                                        <img
                                            src={`${BASE_URL}${fact.Experience_icon_class}`}
                                            alt={fact.title}
                                            className="img-fluid"
                                            style={{ width: "60px", height: "60px" }}
                                        />
                                    </div>
                                    <div className="exp-counter">
                                        <span
                                            data-purecounter-start="0"
                                            data-purecounter-end={fact.Experience_number}
                                            className="purecounter fw-bold fs-2 text-warning"
                                        >
                                            {fact.Experience_number}
                                        </span>
                                        <span className="fs-2 fw-bold text-warning">+</span>
                                    </div>
                                    <p className="mt-2 fw-semibold text-white">
                                        {fact.Experience_main_Line}
                                    </p>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </section>
    );
}

export default Experenise;
